/**
 * InlineFilterEvents
 * Registry of events for the inline filtering
 */
export enum InlineFilterEvents {
    Search = "Inline Filters - Search",
    ClearFilters = "Inline Filters - Clear Filters",
    MultiSelectSelectAll = "Inline Filters - MultiSelect - Select All",
    MultiSelectDeselectAll = "Inline Filters - MultiSelect - Deselect All",
    MultiSelectSelectValue = "Inline Filters - MultiSelect - Select Value",
    MultiSelectDeselectValue = "Inline Filters - MultiSelect - Deselect Value",
}

/**
 * ApiToolsEvents
 * Registry of events for ApiTools panel
 */
export enum ApiToolsEvents {
    OpenApiTools = "API Tools - Open",
    CloseApiTools = "API Tools - Close",
    CodeSampleClick = "API Tools - Click Code Sample Language Option",
    CopyCodeSample = "API Tools - Copy Code Sample",
    CopyQuery = "API Tools - Copy Query",
    ApiDocsLinkClick = "API Tools - Click API Docs Link",
    ApiExplorerLinkClick = "API Tools - Click API Explorer Link",
    TalkToTeamClick = "API Tools - Click Talk To Our Team",
}

/**
 * FilterFormEvents
 * Registry of events for ProSearch FilterForm
 */
export enum FilterFormEvents {
    ChangeField = "Pro Search - Filter Form - Change Field",
    ChangeOperator = "Pro Search - Filter Form - Change Operator",
    ChangeValue = "Pro Search - Filter Form - Change Value",
    ClickClone = "Pro Search - Filter Form - Click Clone",
    ClickDelete = "Pro Search - Filter Form - Click Delete",
}

/**
 * FilterListEvents
 * Registry of events for ProSearch FilterList
 */
export enum FilterListEvents {
    AddGroup = "Pro Search - Filter List - Add Group",
    AddCondition = "Pro Search - Filter List - Add Condition",
    RemoveGroup = "Pro Search - Filter List - Remove Group",
    ToggleAndOr = "Pro Search - Filter List - Toggle And/Or",
    DragDropReorder = "Pro Search - Filter List - Drag/Drop/Reorder",
}

/**
 * FilterControlsEvents
 * Registry of events for ProSearch FilterControls
 */
export enum FilterControlsEvents {
    ApplySearch = "Pro Search - Apply Search",
    DiscardSearch = "Pro Search - Discard Search",
}
